var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-shopping-cart"},[_c('div',{staticClass:"empty-icon"},[_c('img',{attrs:{"src":require("../../public/img/empty.jpg")}})]),_vm._v(" "),_c('p',{staticClass:"empty-text"},[_vm._v("千万好物等待您的挑选")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d92c30c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EmptyShoppingCart/index.vue
// module id = null
// module chunks = 